import type { FC } from 'react';

interface Props {
  className?: string;
}

const ApplianceIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="4" y="2" width="16" height="20" rx="2" strokeWidth="2" />
      <circle cx="8" cy="6" r="1" fill="currentColor" />
      <circle cx="12" cy="6" r="1" fill="currentColor" />
      <circle cx="16" cy="6" r="1" fill="currentColor" />
      <rect x="6" y="10" width="12" height="8" rx="1" strokeWidth="2" />
      <circle cx="12" cy="14" r="2" strokeWidth="2" />
    </svg>
  );
};

export default ApplianceIcon;
